import { ArrowRight, Lightbulb, BarChart3, Users, Globe } from 'lucide-react';
import { useLanguage } from '../i18n/content';
import { FadeUp, Eyebrow } from './Reveal';

const ICONS = {
  lightbulb: Lightbulb,
  chart: BarChart3,
  users: Users,
  globe: Globe,
};

export function About() {
  const { t } = useLanguage();

  return (
    <section id="tentang" className="relative overflow-hidden py-16 lg:py-20">
      <div
        aria-hidden
        className="pointer-events-none absolute left-[-15%] top-1/3 h-[480px] w-[480px] rounded-full bg-[radial-gradient(circle,rgba(229,9,20,0.12),transparent_65%)] blur-2xl"
      />
      <div
        aria-hidden
        className="halftone pointer-events-none absolute right-0 top-0 hidden h-40 w-32 opacity-40 [mask-image:linear-gradient(to_bottom,black,transparent)] lg:block"
      />

      <div className="relative mx-auto grid max-w-7xl items-center gap-10 px-4 sm:px-8 md:grid-cols-2 md:gap-12 lg:px-10">
        <FadeUp>
          <Eyebrow>{t.about.eyebrow}</Eyebrow>
          <h2
            className="mt-4 font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl"
            data-testid="about-title"
          >
            {t.about.titleA}
            <span className="block">
              {t.about.titleB}
              <span className="text-nofina-red">.</span>
            </span>
          </h2>
          <p className="mt-5 text-base leading-relaxed text-slate-400">
            {t.about.text}
          </p>
          <p
            className="mt-4 text-sm leading-relaxed text-slate-300"
            data-testid="about-legal-entity"
          >
            {t.about.legalLine}
          </p>
          <a
            href={t.about.href}
            data-testid="about-learn-more-button"
            className="mt-7 inline-flex items-center gap-2 rounded-xl border border-white/20 bg-white/[0.04] px-6 py-3 text-sm font-semibold text-white transition-all duration-300 hover:border-nofina-red hover:text-nofina-red"
          >
            {t.about.cta}
            <ArrowRight className="h-4 w-4" />
          </a>
        </FadeUp>

        <FadeUp delay={0.1}>
          <div
            className="grid gap-4 sm:grid-cols-2"
            data-testid="about-points"
          >
            {t.about.points.map((p, i) => {
              const Icon = ICONS[p.icon];
              return (
                <div
                  key={p.text}
                  data-testid={`about-point-${i + 1}`}
                  className="rounded-2xl border border-white/10 bg-white/[0.03] p-5 transition-all duration-500 hover:border-nofina-red/40 hover:bg-white/[0.05]"
                >
                  <span className="flex h-10 w-10 items-center justify-center rounded-xl border border-nofina-red/30 bg-nofina-red/10 text-nofina-red">
                    <Icon className="h-5 w-5" />
                  </span>
                  <p className="mt-4 text-sm leading-relaxed text-slate-300">
                    {p.text}
                  </p>
                </div>
              );
            })}
          </div>
        </FadeUp>
      </div>
    </section>
  );
}
